<template>
  <div v-if="show" :class="[typeClass, 'alert-card']">
    <i :class="iconClass"></i>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    type: {
      type: String,
      default: 'info',
      validator: function (value) {
        return ['info', 'success', 'warning', 'error'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    typeClass() {
      return `alert-${this.type}`;
    },
    iconClass() {
      switch (this.type) {
        case 'info':
          return 'bi bi-info-circle-fill';
        case 'success':
          return 'bi bi-check-circle-fill';
        case 'warning':
          return 'bi bi-exclamation-triangle-fill';
        case 'error':
          return 'bi bi-x-circle-fill';
        default:
          return '';
      }
    },
  },
  watch: {
    message(newMessage) {
      if (newMessage) {
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
          setTimeout(() => {
            this.show = false;
          }, this.type === 'error' ? 10000 : 5000);
        });
      }
    },
  },
};
</script>

<style scoped>
.alert-card {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.alert-info {
  background-color: #e2f0ff;
  color: #007bff;
}

.alert-success {
  background-color: #d4edda;
  color: #28a745;
}

.alert-warning {
  background-color: #fff3cd;
  color: #ffc107;
}

.alert-error {
  background-color: #f8d7da;
  color: #dc3545;
}

.alert-card i {
  margin-right: 10px;
}
</style>